
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./ksa-mada.cjs.production.min.js')
} else {
  module.exports = require('./ksa-mada.cjs.development.js')
}
